export const timeRanges = [
  { label: 'Hoje', value: 'day' },
  { label: 'Ontem', value: 'yesterday' },
  { label: 'Últimos 7 dias', value: 'week' },
  { label: 'Últimos 30 dias', value: 'month' },
  { label: 'Personalizado', value: 'custom' }
];